import {
  GetInterceptionMemberRequestParams,
  GetInterceptionNetworkRequestParams,
  GetInterceptionsRequestParams,
  UpdateInterceptionMemberRequestParams,
  UpdateInterceptionNetworkRequestParams,
} from '../interfaces/interceptions';
import axios from '../services/axios';

import { GO_API_PREFIX } from './entities';

export const getInterceptionsList = ({
  memberIds,
  networkIds,
  search,
}: GetInterceptionsRequestParams) =>
  axios.get(`${GO_API_PREFIX}/interceptions`, {
    params: {
      member_ids: memberIds,
      network_ids: networkIds,
      search,
    },
  });

export const getInterceptionById = (id: number) =>
  axios.get(`${GO_API_PREFIX}/interceptions/${id}`);

export const getInterceptionTranscriptsById = (id: number) =>
  axios.get(`${GO_API_PREFIX}/interceptions/${id}/transcripts`);

export const getInterceptionDepartments = () =>
  axios.get(`${GO_API_PREFIX}/interceptions/departments`);

export const updateInterceptionNetworkById = ({
  id,
  ...req
}: UpdateInterceptionNetworkRequestParams) =>
  axios.patch(`${GO_API_PREFIX}/interceptions/networks/${id}`, req);

export const updateInterceptionMemberById = ({
  id,
  ...req
}: UpdateInterceptionMemberRequestParams) =>
  axios.patch(`${GO_API_PREFIX}/interceptions/members/${id}`, req);

export const getInterceptionMembers = ({
  search,
  startDate,
  endDate,
}: GetInterceptionMemberRequestParams) =>
  axios.get(`${GO_API_PREFIX}/interceptions/members`, {
    params: {
      search,
      startDate,
      endDate,
    },
  });

export const getInterceptionNetworks = ({
  search,
  startDate,
  endDate,
}: GetInterceptionNetworkRequestParams) =>
  axios.get(`${GO_API_PREFIX}/interceptions/networks`, {
    params: {
      search,
      startDate,
      endDate,
    },
  });

export const getInterceptionMemberById = (id: string) =>
  axios.get(`${GO_API_PREFIX}/interceptions/members/${id}`);

export const getInterceptionNetworkById = (id: string) =>
  axios.get(`${GO_API_PREFIX}/interceptions/networks/${id}`);
